// extracted by mini-css-extract-plugin
export default {"root":"styles-root-d5607d","viewport":"styles-viewport-d423a4","dialog-scale-start":"styles-dialog-scale-start-a3ad56","container":"styles-container-c40d76"};